import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  TablePagination,
  Toolbar,
  IconButton,
  Grid,
  MenuItem,
  InputAdornment
} from '@mui/material'
import {
  ArrowBack,
  Save,
  Search,
  AdminPanelSettings,
  Visibility,
  VisibilityOff
} from '@mui/icons-material'

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import api from '../../utils/axios'

const perfis = [
  { value: 'agroeconomia', label: 'Agroeconomia' },
  { value: 'educacao', label: 'Educação' }
];

const defaultValues = {
  nome: '',
  cpf: '',
  tipo: 'agroeconomia',
  senha: ''
};

const FormUsuarioAdmin = () => {
  const navigate = useNavigate()

  const [rows, setRows] = useState([]);
  const [itemEdit, setItemEdit] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues
  })

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  const [mode, setMode] = useState('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (mode === "edit" && itemEdit) {
      reset({ ...defaultValues, ...itemEdit, senha: '' });
    } else if (mode === "create" || mode === "Busca" || !itemEdit) {
      reset(defaultValues);
      setRows([]);
    }
  }, [itemEdit, reset, mode]);

  const handleEdit = (item) => {
    setMode('edit');
    setItemEdit(item);
    reset({ ...defaultValues, ...item, senha: '' });
  }

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)

    if (!data.id) {
      try {
        const response = await api.put('/usuarios/save.php', {
          nome: data.nome,
          cpf: data.cpf,
          tipo: data.tipo,
          senha: data.senha
        })

        if (response.data.success) {
          setSuccess('Usuário cadastrado com sucesso!')
        } else {
          setError(response.data.message || 'Erro ao cadastrar usuário')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao cadastrar usuário')
      } finally {
        setLoading(false)
      }
    } else {
      try {
        const response = await api.put('/usuarios/update.php', {
          id: data.id,
          nome: data.nome,
          cpf: data.cpf,
          tipo: data.tipo,
          senha: data.senha || undefined
        })

        if (response.data.success) {
          setSuccess('Dados atualizados com sucesso!')
        } else {
          setError(response.data.message || 'Erro ao atualizar usuário')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar usuário')
      } finally {
        setLoading(false)
      }
    }
  }

  const onSubmitBusca = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)
    setMode('');
    setPage(0);

    try {
      const response = await api.put('/usuarios/list.php', {
        nome: data.nome,
        cpf: data.cpf,
        tipo: data.tipo
      })

      if (response.data.success) {
        setRows(response.data.usuarios)
      } else {
        setError(response.data.message || 'Erro ao buscar usuários')
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao buscar usuários')
    } finally {
      setLoading(false)
    }
  }

  function Row(props) {
    const { row } = props;

    return (
      <TableRow onClick={() => handleEdit(row)} sx={{ cursor: "pointer" }}>
        <TableCell component="th" scope="row">{row.nome}</TableCell>
        <TableCell align="right">{row.cpf}</TableCell>
        <TableCell align="right">{perfis.find(p => p.value === row.tipo)?.label || row.tipo}</TableCell>
      </TableRow>
    );
  }

  const Cadastro = () => {
    return (
      <Container sx={{ py: 3 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <AdminPanelSettings sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Usuário Administrativo
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}

          <form className='admin-form' onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Nome"
                  margin="normal"
                  {...register('nome', {
                    required: 'Nome é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Nome deve ter no mínimo 3 caracteres'
                    }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="CPF"
                  margin="normal"
                  {...register('cpf', {
                    required: 'CPF é obrigatório',
                    pattern: {
                      value: /^\d{11}$/,
                      message: 'CPF deve conter 11 dígitos'
                    }
                  })}
                  error={!!errors.cpf}
                  helperText={errors.cpf?.message}
                  placeholder="00000000000"
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Perfil"
                  margin="normal"
                  {...register('tipo', { required: 'Perfil é obrigatório' })}
                  error={!!errors.tipo}
                  helperText={errors.tipo?.message}
                >
                  {perfis.map((perfil) => (
                    <MenuItem key={perfil.value} value={perfil.value}>{perfil.label}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label={itemEdit ? 'Nova senha (deixe em branco para manter)' : 'Senha'}
                  type={showPassword ? 'text' : 'password'}
                  margin="normal"
                  {...register('senha', {
                    required: itemEdit ? false : 'Senha é obrigatória',
                    minLength: {
                      value: 5,
                      message: 'A senha deve ter no mínimo 5 caracteres'
                    }
                  })}
                  error={!!errors.senha}
                  helperText={errors.senha?.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ mt: 3 }}
                  startIcon={<Save />}
                  disabled={loading}
                >
                  {'Salvar'}
                </Button>

                <Button
                  type={"button"}
                  variant="contained"
                  size="large"
                  onClick={() => setMode('Busca')}
                  sx={{ mt: 3, marginLeft: 2, backgroundColor: '#7469ea' }}
                  startIcon={<KeyboardReturnIcon />}
                  disabled={loading}
                >
                  {'Voltar'}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    )
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/agroeconomia')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <AdminPanelSettings sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Usuários Administrativos
          </Typography>
        </Toolbar>
      </AppBar>

      {mode === 'create' || mode === 'edit'
        ?
        <Cadastro />
        :
        <Container sx={{ py: 3 }}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <AdminPanelSettings sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Usuários Administrativos
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                {success}
              </Alert>
            )}

            <form className='admin-form' onSubmit={handleSubmit(onSubmitBusca)}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Nome"
                    margin="normal"
                    {...register('nome')}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="CPF"
                    margin="normal"
                    {...register('cpf')}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Perfil"
                    margin="normal"
                    defaultValue=""
                    {...register('tipo')}
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {perfis.map((perfil) => (
                      <MenuItem key={perfil.value} value={perfil.value}>{perfil.label}</MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Button
                    type="button"
                    onClick={() => { setItemEdit(null); setMode('create'); }}
                    variant="contained"
                    size="large"
                    sx={{ mt: 3 }}
                    startIcon={<Save />}
                    disabled={loading}
                  >
                    {'Novo'}
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 3, marginLeft: 2, backgroundColor: '#ccdb00' }}
                    startIcon={<Search />}
                    disabled={loading}
                  >
                    {'Buscar'}
                  </Button>
                </Grid>
              </Grid>
            </form>

            {rows && mode !== 'create' && mode !== 'edit' && <React.Fragment>
              <TableContainer component={Paper}>
                <Table aria-label="usuarios table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome</TableCell>
                      <TableCell align="right">CPF</TableCell>
                      <TableCell align="right">Perfil</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => (
                        <Row key={row.id} row={row} />
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
              />
            </React.Fragment>}
          </Paper>
        </Container>
      }
    </Box>
  )
}

export default FormUsuarioAdmin
